// import { LuMoveRight } from "react-icons/lu";
// import { Link } from "react-router-dom";
// import web1 from "../../../assets/images/web-designer/img.png";
// import web11 from "../../../assets/images/web-designer/img-11.png";
// import web11Dark from "../../../assets/images/web-designer/img-11-dark.png";
import { useLayoutContext } from "../../../context/useLayoutContext";
import mainBanner from "../../../assets/images/main_banner.6566ad09.png";
import { useState } from "react";

const Hero = () => {
  const { themeMode } = useLayoutContext();
  const [trackingNumber, setTrackingNumber] = useState("");

  const handleTrackingNumberChange = (e) => {
    setTrackingNumber(e.target.value);
  };

  const handleSearch = () => {
    if (!trackingNumber) {
      return;
    }

    window.open(`/tracking/${trackingNumber}`, "_blank");
  };

  return (
    <section
      id="home"
      className="relative flex items-center justify-center overflow-hidden  bg-cover bg-center bg-no-repeat w-full h-[85vh] py-28"
      style={{
        backgroundImage: `url(${mainBanner})`,
      }}
    >
      <div className="bg- absolute inset-0" />
      <div className="container relative">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div className="col-start-2">
            {/* <span className="text-base font-medium">I'm Ronald Smith</span> */}
            {/* <h2 className="mt-3 text-4xl/snug font-medium text-default-900">
              Visual &amp; Web Designer Located in Melbourne.
            </h2> */}
            {/* <p className="mt-1 text-lg text-black">
              შეიყვანეთ გზავნილის ნომერი
            </p> */}
            <div className="mb-10">
              <div className="max-w-xl rounded-md bg-white backdrop-blur-2xl">
                <form
                  className="mt-6 flex w-full items-center justify-between"
                  onSubmit={handleSearch}
                >
                  <input
                    type="text"
                    name="trackingNumber"
                    id="trackingNumber"
                    className="w-full border-0 bg-transparent p-4 text-base text-default-950 placeholder-black focus:outline-none focus:ring-0"
                    placeholder="შეიყვანეთ გზავნილის ნომერი"
                    onChange={handleTrackingNumberChange}
                  />
                  <button className="me-2 rounded-md border-0 bg-primary px-6 py-2 text-base font-semibold text-white backdrop-blur-2xl transition-all hover:bg-primary-700 hover:text-white">
                    <div className="flex items-center justify-center gap-1">
                      <span>ძიება</span>
                    </div>
                  </button>
                </form>
              </div>
              {/* <small className="mb-6 mt-2 text-sm">
                Don't miss out on your favourite username.
              </small> */}
            </div>
            {/* <Link
              to=""
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-8 py-2 text-white backdrop-blur-3xl transition-all duration-300 hover:border-primary hover:bg-primary-700"
            >
              Read More
              
            </Link> */}
          </div>
          {/* <div className="lg:ms-auto">
            <img src={web1} />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
